import { EnrollmentSelectionReportContainer } from './enrollment-selection-report.container';

export default EnrollmentSelectionReportContainer;
